var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "share-network-container"
  }, [_c('hr'), _c('div', {
    staticClass: "share-network-list-wrapper"
  }, [_c('div', {
    staticClass: "share-network-list"
  }, _vm._l(_vm.networks, function (network) {
    return _c('share-network', {
      key: network.network,
      attrs: {
        "network": network.network,
        "url": _vm.location,
        "title": network.network === 'telegram' ? '' : _vm.getString(_vm.article.card_name || _vm.article.name),
        "media": _vm.article.image
      },
      on: {
        "open": _vm.open
      }
    }, [_c('a', {
      staticClass: "share-network-link",
      attrs: {
        "href": "javascript:"
      }
    }, [_c(network.network + '-icon', {
      key: network.network,
      tag: "component"
    })], 1)]);
  }), 1), _c('div', {
    staticClass: "share-network-copy-link"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.copy($event);
      }
    }
  }, [_vm.copied ? [_vm._v("Скопировано")] : [_vm._v("Скопировать ссылку")]], 2)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }